import { Button } from "primereact/button";
import { useTranslation } from "react-i18next";
import { Dialog } from "primereact/dialog";
import { useCallback, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks";
import { selectShowEvidenceDialog } from "../../store/selectors/rectificationSelector";
import { setShowEvidenceDialog } from "../../store/slices/rectificationSlice";

type Props = {
    onSave: () => void;
};

export const ShowEvidenceDialog = (props: Props) => {
    const { onSave } = props;

    const { t } = useTranslation("locale");
    const dispatch = useAppDispatch();

    const show = useAppSelector(selectShowEvidenceDialog);

    const onHide = useCallback(
        () => dispatch(setShowEvidenceDialog(false)),
        []
    );

    const onContinue = useCallback(() => {
        onHide();
        onSave();
    }, [onSave]);

    const footer = useMemo(
        () => (
            <div className="flex justify-content-center">
                <Button
                    data-cy="show-evidence-cancel"
                    className="w-9rem"
                    label={t("defectRectification.cancel")}
                    text
                    onClick={onHide}
                />
                <Button
                    data-cy="show-evidence-continue"
                    className="w-9rem"
                    label={t("defectRectification.continue")}
                    onClick={onContinue}
                />
            </div>
        ),
        []
    );

    return (
        <Dialog
            header={t("defectRectification.rectifiedWithoutEvidence")}
            visible={show}
            onHide={onHide}
            blockScroll={true}
            footer={footer}
            draggable={false}
            closable={false}
        >
            <p>{t("defectRectification.selectCancel")}</p>
        </Dialog>
    );
};
